/* ==========================================================================
   JRKY THEME — theme.js
   Depends on GSAP + ScrollTrigger (loaded in theme.liquid before this file).
   ========================================================================== */
(function () {
  var root = document.documentElement;
  root.classList.remove('no-js');
  root.classList.add('js');

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = window.matchMedia('(max-width: 860px)').matches;
  if (reduceMotion) root.classList.add('reduce-motion');

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var hasGSAP = typeof window.gsap !== 'undefined' && typeof window.ScrollTrigger !== 'undefined';
    if (hasGSAP) gsap.registerPlugin(ScrollTrigger);

    /* ---------- Theme editor support ----------
       In the customizer, Shopify re-renders sections over AJAX. Our scroll
       observers don't know about the new nodes, so .reveal elements would stay
       at opacity:0 (the section looks blank). In design mode, force reveals
       visible immediately and on every section (re)load. */
    var inDesignMode = window.Shopify && window.Shopify.designMode;
    if (inDesignMode) {
      var showReveals = function (scope) {
        (scope || document).querySelectorAll('.reveal, .reveal-group').forEach(function (el) {
          el.classList.add('is-in');
        });
      };
      showReveals();
      document.addEventListener('shopify:section:load', function (e) { showReveals(e.target); });
    }

    /* ---------- 0. Header: reveal centered logo on scroll ---------- */
    var siteHeader = document.querySelector('[data-header]');
    if (siteHeader) {
      var onHeaderScroll = function () {
        siteHeader.classList.toggle('is-scrolled', window.scrollY > 60);
      };
      window.addEventListener('scroll', onHeaderScroll, { passive: true });
      onHeaderScroll();
    }

    /* ---------- 0b. Mobile menu (hamburger) ---------- */
    var navToggle = document.querySelector('[data-nav-toggle]');
    var mobileMenu = document.querySelector('[data-mobile-menu]');
    var menuOverlay = document.querySelector('[data-mobile-menu-overlay]');
    if (navToggle && mobileMenu && siteHeader) {
      // Reveal the panel/overlay for the CSS transitions (they start hidden for no-JS)
      mobileMenu.hidden = false;
      if (menuOverlay) menuOverlay.hidden = false;

      var setMenu = function (open) {
        siteHeader.classList.toggle('is-menu-open', open);
        navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.style.overflow = open ? 'hidden' : '';
      };
      navToggle.addEventListener('click', function () {
        setMenu(!siteHeader.classList.contains('is-menu-open'));
      });
      if (menuOverlay) menuOverlay.addEventListener('click', function () { setMenu(false); });
      mobileMenu.addEventListener('click', function (e) {
        if (e.target.closest('a')) setMenu(false);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') setMenu(false);
      });
    }

    /* ---------- 1. Hero entrance + layered parallax ---------- */
    var hero = document.querySelector('[data-hero]');
    if (hero && hasGSAP && !reduceMotion) {
      var wordmark = hero.querySelector('.hero__wordmark');
      var sticksRow = hero.querySelector('[data-hero-sticks-row]');
      var sticks = hero.querySelectorAll('[data-hero-stick]');
      var copy = hero.querySelector('.hero__copy');

      // Entrance: wordmark rises, then the 3 sticks rise up from below, staggered.
      var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });
      tl.from(wordmark, { yPercent: 18, opacity: 0, duration: 1 }, 0);
      if (sticks.length) {
        tl.from(sticks, { yPercent: 130, opacity: 0, duration: 1.1, stagger: 0.14 }, 0.15);
      }
      tl.from(copy, { y: 24, opacity: 0, duration: .8 }, 0.55);

      // Parallax: sticks + wordmark drift at different rates on scroll
      if (!isMobile) {
        if (sticksRow) {
          // Gentle upward drift so the sticks stay above the rising section text.
          gsap.to(sticksRow, {
            yPercent: -10, ease: 'none',
            scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true }
          });
        }
        gsap.to(wordmark, {
          yPercent: 10, ease: 'none',
          scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true }
        });
      }
    } else if (hero) {
      // No GSAP / reduced motion: make sure everything is visible
      hero.querySelectorAll('.hero__wordmark, .hero__stick, .hero__copy')
        .forEach(function (el) { el.style.opacity = 1; });
    }

    /* ---------- 2. Scroll reveals (sections slide into frame) ---------- */
    var reveals = document.querySelectorAll('.reveal, .reveal-group');
    if (reveals.length && !reduceMotion) {
      if (hasGSAP) {
        reveals.forEach(function (el) {
          ScrollTrigger.create({
            trigger: el,
            start: 'top 85%',
            once: true,
            onEnter: function () { el.classList.add('is-in'); }
          });
        });
      } else if ('IntersectionObserver' in window) {
        // Graceful fallback if GSAP fails to load
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
          });
        }, { rootMargin: '0px 0px -12% 0px' });
        reveals.forEach(function (el) { io.observe(el); });
      } else {
        reveals.forEach(function (el) { el.classList.add('is-in'); });
      }
    } else {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    }

    /* ---------- 3. Hero thumbnail swap (changes the floating product) ---------- */
    var heroThumbs = document.querySelectorAll('[data-hero-thumb]');
    var heroProductImg = document.querySelector('[data-hero-product-img]');
    if (heroThumbs.length && heroProductImg) {
      heroThumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var src = btn.getAttribute('data-img');
          if (!src) return;
          if (hasGSAP && !reduceMotion) {
            gsap.to(heroProductImg, {
              opacity: 0, yPercent: 8, duration: .25,
              onComplete: function () {
                heroProductImg.setAttribute('src', src);
                gsap.to(heroProductImg, { opacity: 1, yPercent: 0, duration: .35 });
              }
            });
          } else {
            heroProductImg.setAttribute('src', src);
          }
          heroThumbs.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
      });
    }

    /* ---------- 4. Cart: AJAX add / line changes / drawer + section re-render ---------- */
    var cartDrawer = document.querySelector('[data-cart-drawer]');
    var cartToggles = document.querySelectorAll('[data-cart-toggle]');

    function openDrawer() {
      if (!cartDrawer) return;
      cartDrawer.classList.add('is-open');
      cartDrawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('cart-open');
    }
    function closeDrawer() {
      if (!cartDrawer) return;
      cartDrawer.classList.remove('is-open');
      cartDrawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('cart-open');
    }

    cartToggles.forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
    });
    if (cartDrawer) {
      cartDrawer.addEventListener('click', function (e) {
        if (e.target.closest('[data-cart-close]')) closeDrawer();
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    // Swap re-rendered cart markup (drawer + cart page) and sync header count.
    function applyCartSection(html) {
      if (!html) return;
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var fresh = parsed.querySelector('[data-cart-drawer-inner]');
      document.querySelectorAll('[data-cart-drawer-inner]').forEach(function (live) {
        if (fresh) live.innerHTML = fresh.innerHTML;
      });
      // Header count + drawer title count come from the rendered label.
      var label = parsed.querySelector('[data-cart-count-label]');
      var count = label ? (label.textContent.replace(/\D/g, '') || '0') : null;
      if (count !== null) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
      }
      // Let cart widgets (Recharge cross-sell, etc.) re-mount after the inner
      // markup is swapped. They listen for these on most storefronts.
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    }

    function postCart(url, body) {
      body.sections = 'cart-drawer';
      body.sections_url = window.location.pathname;
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    }

    var rechargeCart = root.classList.contains('recharge-cart');

    // Recharge Cart open helper — tries known globals, then dispatches the
    // events Recharge listens for. Used in Recharge-Cart mode only.
    function rechargeAvailable() {
      return !!(window.reChargeCart || window.RechargeCart || (window.recharge && window.recharge.cart));
    }
    function openRechargeCart() {
      try {
        if (window.reChargeCart && window.reChargeCart.open) return window.reChargeCart.open();
        if (window.RechargeCart && window.RechargeCart.open) return window.RechargeCart.open();
        if (window.recharge && window.recharge.cart && window.recharge.cart.open) return window.recharge.cart.open();
      } catch (err) {}
      document.dispatchEvent(new CustomEvent('recharge:cart:open', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    }

    // Cart icon → open Recharge Cart instead of navigating to /cart.
    // Falls back to normal /cart navigation if Recharge isn't detected.
    if (rechargeCart) {
      document.querySelectorAll('[data-cart-toggle], .cart-toggle').forEach(function (el) {
        el.addEventListener('click', function (e) {
          if (rechargeAvailable()) { e.preventDefault(); openRechargeCart(); }
        });
      });
    }

    // Add to cart from any product form
    var productForms = document.querySelectorAll('[data-product-form], form.product-form');
    productForms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-add-btn]');
        var fd = new FormData(form);
        var body = { items: [{}] };
        body.items[0].id = fd.get('id');
        body.items[0].quantity = parseInt(fd.get('quantity') || '1', 10);
        var sellingPlan = fd.get('selling_plan');
        if (sellingPlan) body.items[0].selling_plan = sellingPlan;
        var upsell = form.querySelector('[data-upsell-toggle]');
        if (upsell && upsell.checked && upsell.getAttribute('data-upsell-id')) {
          body.items.push({ id: upsell.getAttribute('data-upsell-id'), quantity: 1 });
        }
        if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }

        if (rechargeCart) {
          // AJAX add (no page reload) so Recharge Cart can intercept and open.
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(body)
          }).then(function (r) { return r.json(); })
            .then(function () {
              document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
              openRechargeCart();
            })
            .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } });
          return;
        }

        // Built-in drawer path
        postCart('/cart/add.js', body)
          .then(function (res) {
            if (res.status && res.status >= 400) { return; } // sold out / invalid
            return fetch('?sections=cart-drawer').then(function (r) { return r.json(); })
              .then(function (sec) { applyCartSection(sec['cart-drawer']); openDrawer(); });
          })
          .finally(function () {
            if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
          });
      });
    });

    // Delegated line-item changes (drawer + cart page). Skipped under Recharge Cart.
    if (!rechargeCart) {
      var changeLine = function (line, qty) {
        postCart('/cart/change.js', { line: line, quantity: qty })
          .then(function (res) { applyCartSection(res.sections && res.sections['cart-drawer']); });
      };
      document.addEventListener('click', function (e) {
        var row = e.target.closest('[data-cart-item]');
        if (!row) return;
        var line = parseInt(row.getAttribute('data-line'), 10);
        var input = row.querySelector('[data-line-qty]');
        if (e.target.closest('[data-line-remove]')) { changeLine(line, 0); }
        else if (e.target.closest('[data-line-plus]')) { changeLine(line, parseInt(input.value, 10) + 1); }
        else if (e.target.closest('[data-line-minus]')) { changeLine(line, Math.max(0, parseInt(input.value, 10) - 1)); }
      });
      document.addEventListener('change', function (e) {
        if (!e.target.matches('[data-line-qty]')) return;
        var row = e.target.closest('[data-cart-item]');
        changeLine(parseInt(row.getAttribute('data-line'), 10), Math.max(0, parseInt(e.target.value, 10) || 0));
      });
    }

    /* ---------- 5. Product buy box: gallery, variants, qty, subscription ---------- */
    var productSection = document.querySelector('[data-product-section]');
    if (productSection) {
      var galleryMain = productSection.querySelector('[data-gallery-main]');
      var thumbs = productSection.querySelectorAll('[data-gallery-thumb]');

      function showMedia(mediaId, imgSrc) {
        if (!galleryMain) return;
        if (imgSrc) galleryMain.setAttribute('src', imgSrc);
        if (mediaId != null) galleryMain.setAttribute('data-media-id', mediaId);
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-media-id') === String(mediaId));
        });
      }
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          showMedia(thumb.getAttribute('data-media-id'), thumb.getAttribute('data-img'));
        });
      });

      // Per-template pack photos: swap the main image to match the 10 / 24 pack size.
      var galleryEl = productSection.querySelector('[data-pdp-gallery]');
      var pack10 = galleryEl ? galleryEl.getAttribute('data-pack-10') : '';
      var pack24 = galleryEl ? galleryEl.getAttribute('data-pack-24') : '';
      function applyPackImage(opts) {
        if (!galleryMain || (!pack10 && !pack24)) return;
        var joined = (opts || []).join(' ');
        var src = '';
        if (/24/.test(joined) && pack24) src = pack24;
        else if (/10/.test(joined) && pack10) src = pack10;
        if (src) {
          galleryMain.setAttribute('src', src);
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        }
      }

      // Variant data
      var variants = [];
      var json = productSection.querySelector('[data-variants-json]');
      if (json) { try { variants = JSON.parse(json.textContent); } catch (err) { variants = []; } }

      var form = productSection.querySelector('form.product-form');
      var idInput = productSection.querySelector('[data-variant-id]');
      var addBtn = productSection.querySelector('[data-add-btn]');
      var addText = productSection.querySelector('[data-add-text]');
      var priceWrap = productSection.querySelector('[data-price-block]');
      var stickyPrice = productSection.querySelector('[data-sticky-price]');
      var stickyAddBtn = productSection.querySelector('[data-sticky-add]');

      function currentOptions() {
        var picks = [];
        productSection.querySelectorAll('[data-option-input]:checked').forEach(function (r) {
          picks[parseInt(r.getAttribute('data-position'), 10) - 1] = r.value;
        });
        return picks;
      }
      function matchVariant(opts) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }
      function money(cents) {
        return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
      }
      function getVariant() { return matchVariant(currentOptions()) || variants[0]; }
      function planAllocation(v, planId) {
        var allocs = (v && v.selling_plan_allocations) || [];
        for (var i = 0; i < allocs.length; i++) {
          if (String(allocs[i].selling_plan_id) === String(planId)) return allocs[i];
        }
        return null;
      }
      function isSubscription() {
        var sub = productSection.querySelector('[data-purchase-type="subscription"]');
        return !!(sub && sub.checked);
      }
      function renderPrice(v) {
        if (!v) return;
        var alloc = planSelect ? planAllocation(v, planSelect.value) : null;
        // Update the one-time / subscribe option labels (Recharge discounted price)
        var oneEl = productSection.querySelector('[data-onetime-price]');
        if (oneEl) oneEl.textContent = money(v.price);
        var subEl = productSection.querySelector('[data-sub-price]');
        if (subEl) {
          if (alloc) {
            subEl.innerHTML = (v.price > alloc.price ? '<s>' + money(v.price) + '</s> ' : '') + money(alloc.price);
          } else { subEl.textContent = money(v.price); }
        }
        var badgeEl = productSection.querySelector('[data-sub-badge]');
        if (badgeEl && alloc && v.price > alloc.price) {
          badgeEl.textContent = 'Save ' + Math.round((v.price - alloc.price) / v.price * 100) + '%';
          badgeEl.hidden = false;
        }
        // Effective price for the main price block + sticky bar
        var price = v.price, compare = v.compare_at_price;
        if (isSubscription() && alloc) { price = alloc.price; compare = alloc.compare_at_price; }
        if (priceWrap) {
          var cur = priceWrap.querySelector('[data-price-current]');
          var cmp = priceWrap.querySelector('[data-price-compare]');
          if (cur) cur.textContent = money(price);
          if (cmp) { cmp.style.display = compare > price ? '' : 'none'; if (compare > price) cmp.textContent = money(compare); }
        }
        if (stickyPrice) stickyPrice.textContent = money(price);
      }
      function selectVariant() {
        var v = matchVariant(currentOptions());
        if (!v) return;
        if (idInput) idInput.value = v.id;
        // update selected-value labels
        productSection.querySelectorAll('[data-option-selected]').forEach(function (lbl) {
          var pos = parseInt(lbl.getAttribute('data-option-selected'), 10);
          lbl.textContent = v.options[pos - 1];
        });
        // pill active states
        productSection.querySelectorAll('.vpill').forEach(function (p) {
          var input = p.querySelector('input');
          p.classList.toggle('is-active', input && input.checked);
        });
        renderPrice(v);
        // availability
        var soldOut = !v.available;
        [addBtn, stickyAddBtn].forEach(function (b) { if (b) { b.disabled = soldOut; } });
        if (addText && addBtn) addText.textContent = soldOut ? (addBtn.getAttribute('data-soldout-label') || 'Sold out') : (addBtn.getAttribute('data-add-label') || 'Add to cart');
        // gallery → variant media
        if (v.featured_media && v.featured_media.id != null) {
          var t = productSection.querySelector('[data-gallery-thumb][data-media-id="' + v.featured_media.id + '"]');
          showMedia(v.featured_media.id, t ? t.getAttribute('data-img') : (v.featured_media.preview_image ? v.featured_media.preview_image.src : null));
        }
        // pack photos override the gallery image to match the selected 10 / 24 pack
        applyPackImage(v.options);
        // reflect in URL
        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url);
        }
      }
      productSection.querySelectorAll('[data-option-input]').forEach(function (r) {
        r.addEventListener('change', selectVariant);
      });
      // Initial load: show the pack photo matching the default-selected size.
      applyPackImage(currentOptions());

      // Buy-box quantity steppers (scoped; cart-item steppers handled separately)
      var qtyBox = productSection.querySelector('.pblock--qty [data-qty]');
      if (qtyBox) {
        var qInput = qtyBox.querySelector('[data-qty-input]');
        qtyBox.querySelector('[data-qty-plus]').addEventListener('click', function () { qInput.value = parseInt(qInput.value, 10) + 1; });
        qtyBox.querySelector('[data-qty-minus]').addEventListener('click', function () { qInput.value = Math.max(1, parseInt(qInput.value, 10) - 1); });
      }

      // Subscription toggle → enable/disable selling_plan input
      var planInput = productSection.querySelector('[data-selling-plan]');
      var planSelect = productSection.querySelector('[data-selling-plan-select]');
      function syncPlan() {
        var sub = productSection.querySelector('[data-purchase-type="subscription"]');
        if (planInput) {
          if (sub && sub.checked && planSelect) {
            planInput.disabled = false;
            planInput.value = planSelect.value;
          } else {
            planInput.disabled = true;
            planInput.value = '';
          }
        }
        // reflect one-time vs subscription pricing
        renderPrice(getVariant());
      }
      productSection.querySelectorAll('[data-purchase-type]').forEach(function (r) { r.addEventListener('change', syncPlan); });
      if (planSelect) planSelect.addEventListener('change', syncPlan);

      // Sticky add mirrors the main form
      if (stickyAddBtn && form) {
        stickyAddBtn.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
        });
      }

      // Sticky ATC bar visibility
      var stickyBar = document.querySelector('[data-sticky-atc]');
      var buyCol = productSection.querySelector('.product-main__buy');
      if (stickyBar && buyCol && !isMobile) {
        var toggleSticky = function (show) { stickyBar.classList.toggle('is-visible', show); stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true'); };
        if (hasGSAP) {
          ScrollTrigger.create({ trigger: buyCol, start: 'bottom 60%', onEnter: function () { toggleSticky(true); }, onLeaveBack: function () { toggleSticky(false); } });
        } else if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) { toggleSticky(!entries[0].isIntersecting && entries[0].boundingClientRect.top < 0); }, { threshold: 0 }).observe(buyCol);
        }
      }
    }

    /* ---------- 6. Benefits accordion: single-open + image swap ---------- */
    var benefits = document.querySelector('[data-benefits]');
    if (benefits) {
      var bImg = benefits.querySelector('[data-benefits-img]');
      var bRows = benefits.querySelectorAll('[data-acc]');
      bRows.forEach(function (row) {
        row.addEventListener('toggle', function () {
          if (!row.open) return;
          bRows.forEach(function (other) { if (other !== row) other.open = false; });
          var src = row.getAttribute('data-benefit-img');
          if (bImg && src) bImg.setAttribute('src', src);
        });
      });
    }

    /* ---------- 7. Hotspots: tap-to-toggle on touch ---------- */
    document.querySelectorAll('[data-hotspots]').forEach(function (stage) {
      stage.querySelectorAll('[data-hotspot-dot]').forEach(function (dot) {
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          var spot = dot.closest('.hotspot');
          var wasOpen = spot.classList.contains('is-open');
          stage.querySelectorAll('.hotspot').forEach(function (s) { s.classList.remove('is-open'); });
          if (!wasOpen) spot.classList.add('is-open');
        });
      });
    });

    /* ---------- 8. Related products: async load via recommendations route ---------- */
    var related = document.querySelector('[data-related]');
    if (related && related.getAttribute('data-related-url')) {
      fetch(related.getAttribute('data-related-url'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('[data-related] .product-grid');
          var live = related.querySelector('.product-grid');
          if (fresh && live) {
            live.innerHTML = fresh.innerHTML;
            live.classList.add('is-in');
          }
        })
        .catch(function () {});
    }

    /* ---------- 9. Ingredient scroll: pinned reveal + rising product ---------- */
    var ingScroll = document.querySelector('[data-ingredient-scroll]');
    if (ingScroll) {
      var ingLines = ingScroll.querySelectorAll('[data-line]');
      var ingProduct = ingScroll.querySelector('[data-scroll-product]');
      var ingFloats = ingScroll.querySelectorAll('[data-float]');
      var noScene = ingScroll.classList.contains('ing-scroll--no-scene');
      var canAnimate = hasGSAP && !reduceMotion && !inDesignMode && ingLines.length;

      if (canAnimate && noScene) {
        // Text-only (e.g. homepage): each line slides up in a stagger that plays
        // once when the section scrolls into view. No pin/scrub, so it behaves
        // identically on desktop and mobile.
        gsap.set(ingLines, { yPercent: 120 });
        gsap.timeline({
          scrollTrigger: { trigger: ingScroll, start: 'top 80%', once: true }
        }).to(ingLines, { yPercent: 0, ease: 'power3.out', duration: 0.7, stagger: 0.22 });
      } else if (canAnimate && !isMobile) {
        // Scene variant: scrubbed reveal + product rising out of the bag (desktop only).
        gsap.set(ingLines, { yPercent: 115 });
        if (ingLines[0]) gsap.set(ingLines[0], { yPercent: 0 });   // first line visible from the start
        if (ingProduct) gsap.set(ingProduct, { yPercent: 60 });
        ingFloats.forEach(function (f) { gsap.set(f, { yPercent: 25, opacity: 0 }); });

        var unit = 0.8;
        var span = (ingLines.length - 1) * unit;
        var ingTl = gsap.timeline({
          scrollTrigger: {
            trigger: ingScroll,
            start: 'top 92%',   // begin revealing as soon as the section scrolls into view
            end: '+=110%',
            scrub: 1
          }
        });
        // reveal lines 2..N on scroll (line 1 is already shown)
        ingLines.forEach(function (ln, i) {
          if (i === 0) return;
          ingTl.to(ln, { yPercent: 0, ease: 'power3.out', duration: unit }, (i - 1) * unit);
        });
        if (ingProduct) ingTl.to(ingProduct, { yPercent: -32, ease: 'none', duration: span }, 0);
        ingFloats.forEach(function (f, i) {
          ingTl.to(f, { yPercent: (i % 2 ? -35 : -22), xPercent: (i % 2 ? 6 : -6), rotation: (i % 2 ? 10 : -8), opacity: 1, ease: 'none', duration: span }, 0);
        });
      } else {
        // Static fallback — make sure nothing is left hidden.
        ingLines.forEach(function (ln) { ln.style.transform = 'none'; });
        if (ingProduct) ingProduct.style.transform = 'none';
        ingFloats.forEach(function (f) { f.style.opacity = 1; });
      }
    }
  });
})();
